import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceForm, {
  ServiceFormFields,
} from '../../components/Service/ServiceForm';
import api from '../../services/api';
import { useAuth } from '../../contexts/auth';

export default function ServicesNew() {
  const {
    user: { organization },
  } = useAuth();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({});

  const onSubmit = async (data: ServiceFormFields) => {
    try {
      await api.post(`organizations/${organization.id}/services`, data);

      navigate('/services');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  const [formFields, setFormFields] = useState<ServiceFormFields>(
    {} as ServiceFormFields
  );

  return (
    <ServiceForm
      isLoading={1 + 1 === 1}
      title='Novo'
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
